// extracted by mini-css-extract-plugin
export default {"loginPage":"Login_loginPage__wXp9M","loginBtn":"Login_loginBtn__5Y7HR","spotify_logo":"Login_spotify_logo__9D45h"};